<template>
  <div class="circle-popup">
    <table class="table table-sm table-bordered">
      <tr><td>vehicle</td><td>{{ data.device }}</td></tr>
      <tr><td>owner</td><td>{{ data.owner }}</td></tr>
      <tr><td>contract</td><td>{{ data.contract }}</td></tr>
      <tr><td>type</td><td>{{ data.type }}</td></tr>
      <tr><td>tag</td><td>{{ data.tag }}</td></tr>
      <tr><td>code</td><td>{{ data.code }}</td></tr>
      <tr><td>time</td><td>{{data.lastupdate }}</td></tr>
      <tr><td>ago</td><td>{{ timeToString(data.lastupdate) }}</td></tr>
      <tr><td>location</td>
        <td>
        <a target="_blank" :href="`https://www.google.com/maps/?q=${data.latitude},${data.longitude}`">
          {{data.latitude}},{{data.longitude}}
        </a>
      </td>
      </tr>
    </table>
  </div>
</template>

<script>

import { timeToString } from '@/utils/time.utils'

export default {
  props: {
    data: Object
  },
  setup() {
    return {
      timeToString
    }
  }
};
</script>